/* eslint-disable ember/new-module-imports */
import Ember from 'ember';
import esc from "../../../../../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";
let Checkbox;
{
  Checkbox = esc(require('@ember/legacy-built-in-components/components/checkbox')).default;
}
let LinkComponent;
{
  LinkComponent = esc(require('@ember/legacy-built-in-components/components/link-to')).default;
}
let TextArea;
{
  TextArea = esc(require('@ember/legacy-built-in-components/components/textarea')).default;
}
let TextField;
{
  TextField = esc(require('@ember/legacy-built-in-components/components/text-field')).default;
}
export { Checkbox, LinkComponent, TextArea, TextField };